// extracted by mini-css-extract-plugin
module.exports = {"inner":"_TE6t9tZ","content":"_3P7d4ZG","article":"_2ehNqYa","title":"_uhpw5DJ","articleBody":"_3oA7chN"};